export default __webpack_public_path__ + "static/media/Ofuro_Premium_package.c6cc2a7d.jpg";